import { render, staticRenderFns } from "./PRCardApplicationView.vue?vue&type=template&id=2afbf286&scoped=true"
import script from "./PRCardApplicationView.vue?vue&type=script&lang=js"
export * from "./PRCardApplicationView.vue?vue&type=script&lang=js"
import style0 from "./PRCardApplicationView.vue?vue&type=style&index=0&id=2afbf286&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afbf286",
  null
  
)

export default component.exports